import { createI18nProvider, type I18nConfig } from "@rpgjs/common";

export const RpgClientBuiltinI18n = {
  en: {
    "rpg.options.language": "Language",
    "rpg.options.language-auto": "Automatic — browser",
    "rpg.ui.close": "Close",
    "rpg.menu.close-confirmation": "Close confirmation",
    "rpg.stat.atk": "ATK",
    "rpg.stat.pdef": "PDEF",
    "rpg.stat.sdef": "SDEF",
    "rpg.stat.str": "STR",
    "rpg.stat.dex": "DEX",
    "rpg.stat.int": "INT",
    "rpg.stat.agi": "AGI",
    "rpg.menu.no-items": "Your satchel is empty",
    "rpg.menu.no-items-help": "Items collected on your journey will appear here.",
    "rpg.menu.no-equipment": "No equipment available",
    "rpg.menu.no-equipment-help": "Collect weapons and armor to prepare for your next adventure.",
    "rpg.menu.no-skills": "No skills learned yet",
    "rpg.menu.no-skills-help": "New abilities will appear as your hero progresses.",
    "rpg.shop.title": "Merchant",
    "rpg.shop.no-items": "Nothing to trade",
    "rpg.shop.no-sell-help": "You have no items to sell in this category.",
    "rpg.shop.no-buy-help": "The merchant has no stock in this category.",
    "rpg.shop.unavailable": "Unavailable",
    "rpg.shop.no-price-help": "This item is not available for trade.",
    "rpg.shop.not-enough-gold": "You do not have enough gold.",
    "rpg.shop.select-item": "Select an item to inspect its properties.",
    "rpg.cinematic.title": "Cinematic",
    "rpg.cinematic.loading": "Loading cinematic…",
    "rpg.cinematic.play": "Play cinematic",
    "rpg.cinematic.skip": "Skip · Escape",
    "rpg.cinematic.error": "This cinematic could not be played.",
    "rpg.cinematic.close": "Return to game",
    "rpg.menu.title": "Menu",
    "rpg.menu.status": "Status",
    "rpg.menu.level": "Level",
    "rpg.menu.gold": "Gold",
    "rpg.menu.parameters": "Parameters",
    "rpg.menu.items": "Items",
    "rpg.menu.skills": "Skills",
    "rpg.menu.equip": "Equip",
    "rpg.menu.options": "Options",
    "rpg.menu.save": "Save",
    "rpg.menu.exit": "Exit",
    "rpg.menu.weapons": "Weapons",
    "rpg.menu.armor": "Armor",
    "rpg.menu.use": "Use",
    "rpg.menu.hp-value": "HP {value}/{max}",
    "rpg.menu.sp-value": "SP {value}/{max}",
    "rpg.menu.exp-value": "EXP {value}/{max}",
    "rpg.ui.labeled-value": "{label}: {value}",
    "rpg.menu.use-item": "Use {name}?",
    "rpg.menu.level-value": "Level {level}",
    "rpg.menu.cancel": "Cancel",
    "rpg.menu.unequip": "Unequip",
    "rpg.menu.remove-equipment": "Remove the current equipment",
    "rpg.menu.empty": "Empty",
    "rpg.menu.leave-game": "Leave the game?",
    "rpg.menu.exit-help": "Press Action to confirm or Escape to go back.",
    "rpg.menu.options-help": "Configure your preferences here.",
    "rpg.equip.attributes": "Equipment attributes",
    "rpg.equip.comparison": "Current → preview · change shown at right",
    "rpg.controls.title": "Controls",
    "rpg.controls.movement": "Keyboard bindings",
    "rpg.controls.help": "Select a command, then press a key. Escape cancels, except when assigning Back. You can also use the Cancel button.",
    "rpg.controls.action": "Action",
    "rpg.controls.escape": "Back / menu",
    "rpg.controls.cancel": "Cancel",
    "rpg.controls.key.space": "Space",
    "rpg.controls.key.enter": "Enter",
    "rpg.controls.key.escape": "Esc",
    "rpg.controls.key.backspace": "Backspace",
    "rpg.controls.up": "Move up",
    "rpg.controls.down": "Move down",
    "rpg.controls.left": "Move left",
    "rpg.controls.right": "Move right",
    "rpg.controls.listen": "Press a key…",
    "rpg.controls.conflict": "Key unavailable. Use an unused letter, arrow, Space, Enter, Escape or Backspace.",
    "rpg.controls.saved": "Applied immediately. Preferences are kept in this browser when storage is available.",
    "rpg.controls.reset": "Reset key bindings",
    "rpg.audio.title": "Audio",
    "rpg.audio.help": "Adjust each sound category. Your choices are saved in this browser.",
    "rpg.audio.master": "Master volume",
    "rpg.audio.music": "Music",
    "rpg.audio.sfx": "Sound effects",
    "rpg.audio.ui": "Interface",
    "rpg.menu.assign-hotbar": "Assign to hotbar",
    "rpg.menu.assigned-slot": "Assigned slot {slot}",
    "rpg.menu.manage-in-equip": "Manage this equipment from the Equip menu.",
    "rpg.menu.choose-hotbar-slot": "Choose a hotbar slot",
    "rpg.menu.clear-hotbar-slot": "Clear slot",
    "rpg.menu.hotbar-slot-locked": "Locked slot",
    "rpg.menu.skill-hotbar-help": "Select a skill, then press 1–0 to assign it instantly.",
    "rpg.menu.range": "Range",
    "rpg.menu.cooldown": "Cooldown",
    "rpg.hotbar.choose": "Choose an action",
    "rpg.hotbar.radial": "Hotbar radial menu",
    "rpg.hotbar.release": "Release LB to use",
    "rpg.hotbar.release-select": "Release LB to select",
    "rpg.hotbar.slot": "Slot {index}",
    "rpg.action-battle.targeting-help": "Move the target · Action to confirm · Escape to cancel",
    "rpg.save.title": "Save Game",
    "rpg.save.subtitle": "Choose a slot to overwrite or create.",
    "rpg.load.title": "Load Game",
    "rpg.load.subtitle": "Select a slot to load your progress.",
    "rpg.save.auto": "Auto Save",
    "rpg.save.slot": "Slot {index}",
    "rpg.save.empty-slot": "Empty Slot",
    "rpg.save.level": "Level",
    "rpg.save.exp": "Exp",
    "rpg.save.map": "Map",
    "rpg.save.date": "Date",
    "rpg.title.default": "RPG",
    "rpg.title.start": "Start",
    "rpg.title.load": "Load",
    "rpg.character-select.title": "Choose your hero",
    "rpg.character-select.subtitle": "Select the character you want to play.",
    "rpg.character-select.confirm": "Confirm",
    "rpg.character-select.cancel": "Cancel",
    "rpg.character-select.previous": "Previous hero",
    "rpg.character-select.next": "Next hero",
    "rpg.character-select.hint": "You can customize your hero and their abilities later in the game.",
    "rpg.character-select.stats": "Hero statistics",
    "rpg.character-select.stat.life": "Life",
    "rpg.character-select.stat.strength": "Strength",
    "rpg.character-select.stat.defense": "Defense",
    "rpg.character-select.stat.speed": "Speed",
    "rpg.character-select.stat.magic": "Magic",
    "rpg.gameover.title": "Game Over",
    "rpg.gameover.title-screen": "Title Screen",
    "rpg.gameover.load-game": "Load Game",
    "rpg.input.confirm": "Confirm",
    "rpg.input.cancel": "Cancel",
    "rpg.input.error.invalid": "Invalid value.",
    "rpg.input.error.required": "A value is required.",
    "rpg.input.error.number": "Enter a valid number.",
    "rpg.input.error.min": "The value must be at least {min}.",
    "rpg.input.error.max": "The value must be at most {max}.",
    "rpg.input.error.step": "The value must use increments of {step}.",
    "rpg.input.error.min-length": "Enter at least {minLength} characters.",
    "rpg.input.error.max-length": "Enter no more than {maxLength} characters.",
    "rpg.input.error.email": "Enter a valid email address.",
    "rpg.transition.loading": "Loading area…",
    "rpg.shop.default-message": "Welcome to my shop!",
    "rpg.shop.choose-action": "Choose an action",
    "rpg.shop.buy": "Buy",
    "rpg.shop.sell": "Sell",
    "rpg.shop.back": "Back",
    "rpg.shop.equipped": "Equipped",
    "rpg.shop.already-equipped": "Already equipped",
    "rpg.shop.qty": "Qty",
    "rpg.shop.available": "Available",
    "rpg.shop.quantity": "Quantity",
    "rpg.shop.total": "Total",
  },
  fr: {
    "rpg.menu.title": "Menu",
    "rpg.menu.level": "Niveau",
    "rpg.menu.gold": "Or",
    "rpg.menu.parameters": "Caractéristiques",
    "rpg.menu.items": "Objets",
    "rpg.menu.skills": "Compétences",
    "rpg.menu.equip": "Équipement",
    "rpg.menu.options": "Options",
    "rpg.menu.save": "Sauvegarder",
    "rpg.menu.exit": "Quitter",
    "rpg.menu.weapons": "Armes",
    "rpg.menu.armor": "Armures",
    "rpg.menu.use": "Utiliser",
    "rpg.menu.hp-value": "PV {value}/{max}",
    "rpg.menu.sp-value": "PM {value}/{max}",
    "rpg.menu.exp-value": "EXP {value}/{max}",
    "rpg.ui.labeled-value": "{label} : {value}",
    "rpg.menu.use-item": "Utiliser {name} ?",
    "rpg.menu.level-value": "Niveau {level}",
    "rpg.menu.cancel": "Annuler",
    "rpg.menu.unequip": "Retirer",
    "rpg.menu.remove-equipment": "Retirer l’équipement actuel",
    "rpg.menu.empty": "Vide",
    "rpg.menu.leave-game": "Quitter le jeu ?",
    "rpg.menu.exit-help": "Appuyez sur Action pour confirmer ou Échap pour revenir.",
    "rpg.menu.options-help": "Personnalisez vos préférences ici.",
    "rpg.menu.assign-hotbar": "Assigner à un raccourci",
    "rpg.menu.assigned-slot": "Raccourci {slot} assigné",
    "rpg.menu.manage-in-equip": "Gérez cet objet dans le menu Équipement.",
    "rpg.menu.choose-hotbar-slot": "Choisissez un emplacement de raccourci",
    "rpg.menu.clear-hotbar-slot": "Vider l’emplacement",
    "rpg.menu.hotbar-slot-locked": "Emplacement verrouillé",
    "rpg.menu.skill-hotbar-help": "Choisissez une compétence, puis appuyez sur 1–0 pour l’assigner.",
    "rpg.menu.range": "Portée",
    "rpg.menu.cooldown": "Recharge",
    "rpg.hotbar.choose": "Choisissez une action",
    "rpg.hotbar.radial": "Menu circulaire des raccourcis",
    "rpg.hotbar.release": "Relâchez LB pour utiliser",
    "rpg.hotbar.release-select": "Relâchez LB pour sélectionner",
    "rpg.hotbar.slot": "Emplacement {index}",
    "rpg.action-battle.targeting-help": "Déplacez la cible · Action pour confirmer · Échap pour annuler",
    "rpg.save.title": "Sauvegarder la partie",
    "rpg.save.subtitle": "Choisissez un emplacement à créer ou remplacer.",
    "rpg.load.title": "Charger une partie",
    "rpg.load.subtitle": "Choisissez la progression à reprendre.",
    "rpg.save.auto": "Sauvegarde automatique",
    "rpg.save.slot": "Emplacement {index}",
    "rpg.save.empty-slot": "Emplacement vide",
    "rpg.save.level": "Niveau",
    "rpg.save.exp": "Expérience",
    "rpg.save.map": "Carte",
    "rpg.save.date": "Date",
    "rpg.title.default": "RPG",
    "rpg.title.start": "Commencer",
    "rpg.title.load": "Charger",
    "rpg.gameover.title": "Fin de partie",
    "rpg.gameover.title-screen": "Écran titre",
    "rpg.gameover.load-game": "Charger une partie",
    "rpg.input.confirm": "Confirmer",
    "rpg.input.cancel": "Annuler",
    "rpg.input.error.invalid": "Valeur invalide.",
    "rpg.input.error.required": "Une valeur est nécessaire.",
    "rpg.input.error.number": "Saisissez un nombre valide.",
    "rpg.input.error.min": "La valeur doit être au moins {min}.",
    "rpg.input.error.max": "La valeur doit être au plus {max}.",
    "rpg.input.error.step": "La valeur doit respecter un pas de {step}.",
    "rpg.input.error.min-length": "Saisissez au moins {minLength} caractères.",
    "rpg.input.error.max-length": "Saisissez au plus {maxLength} caractères.",
    "rpg.input.error.email": "Saisissez une adresse e-mail valide.",
    "rpg.transition.loading": "Chargement de la zone…",
    "rpg.shop.default-message": "Bienvenue dans ma boutique !",
    "rpg.shop.choose-action": "Choisissez une action",
    "rpg.shop.buy": "Acheter",
    "rpg.shop.sell": "Vendre",
    "rpg.shop.back": "Retour",
    "rpg.shop.equipped": "Équipé",
    "rpg.shop.already-equipped": "Déjà équipé",
    "rpg.shop.qty": "Qté",
    "rpg.shop.available": "Disponible",
    "rpg.shop.quantity": "Quantité",
    "rpg.shop.total": "Total",
    "rpg.options.language": "Langue",
    "rpg.options.language-auto": "Automatique — navigateur",
    "rpg.menu.status": "Statut",
    "rpg.ui.close": "Fermer",
    "rpg.menu.close-confirmation": "Fermer la confirmation",
    "rpg.stat.atk": "ATQ",
    "rpg.stat.pdef": "DEF P",
    "rpg.stat.sdef": "DEF S",
    "rpg.stat.str": "FOR",
    "rpg.stat.dex": "DEX",
    "rpg.stat.int": "INT",
    "rpg.stat.agi": "AGI",
    "rpg.menu.no-items": "Votre sacoche est vide",
    "rpg.menu.no-items-help": "Les objets trouvés au fil de votre aventure apparaîtront ici.",
    "rpg.menu.no-equipment": "Aucun équipement disponible",
    "rpg.menu.no-equipment-help": "Trouvez des armes et armures pour préparer votre prochaine aventure.",
    "rpg.menu.no-skills": "Aucune compétence apprise",
    "rpg.menu.no-skills-help": "De nouvelles capacités apparaîtront au fil de votre progression.",
    "rpg.shop.title": "Marchand",
    "rpg.shop.no-items": "Rien à échanger",
    "rpg.shop.no-sell-help": "Vous n’avez aucun objet à vendre dans cette catégorie.",
    "rpg.shop.no-buy-help": "Le marchand n’a aucun objet dans cette catégorie.",
    "rpg.shop.unavailable": "Indisponible",
    "rpg.shop.no-price-help": "Cet objet n’est pas disponible à l’échange.",
    "rpg.shop.not-enough-gold": "Vous n’avez pas assez d’or.",
    "rpg.shop.select-item": "Sélectionnez un objet pour examiner ses propriétés.",
    "rpg.cinematic.title": "Cinématique",
    "rpg.cinematic.loading": "Chargement de la cinématique…",
    "rpg.cinematic.play": "Lire la cinématique",
    "rpg.cinematic.skip": "Passer · Échap",
    "rpg.cinematic.error": "Impossible de lire cette cinématique.",
    "rpg.cinematic.close": "Revenir au jeu",
    "rpg.equip.attributes": "Attributs de l’équipement",
    "rpg.equip.comparison": "Actuel → prévision · variation à droite",
    "rpg.controls.title": "Commandes",
    "rpg.controls.movement": "Touches du clavier",
    "rpg.controls.help": "Sélectionnez une commande, puis une touche. Échap annule, sauf pour assigner Retour. Le bouton Annuler reste disponible.",
    "rpg.controls.action": "Action",
    "rpg.controls.escape": "Retour / menu",
    "rpg.controls.cancel": "Annuler",
    "rpg.controls.key.space": "Espace",
    "rpg.controls.key.enter": "Entrée",
    "rpg.controls.key.escape": "Échap",
    "rpg.controls.key.backspace": "Retour arrière",
    "rpg.controls.up": "Monter",
    "rpg.controls.down": "Descendre",
    "rpg.controls.left": "Aller à gauche",
    "rpg.controls.right": "Aller à droite",
    "rpg.controls.listen": "Appuyez sur une touche…",
    "rpg.controls.conflict": "Touche indisponible. Utilisez une lettre, une flèche, Espace, Entrée, Échap ou Retour arrière non utilisée.",
    "rpg.controls.saved": "Appliqué immédiatement. Préférences conservées dans ce navigateur si le stockage est disponible.",
    "rpg.controls.reset": "Réinitialiser les touches",
    "rpg.audio.title": "Audio",
    "rpg.audio.help": "Réglez chaque catégorie sonore. Vos choix sont enregistrés dans ce navigateur.",
    "rpg.audio.master": "Volume général",
    "rpg.audio.music": "Musique",
    "rpg.audio.sfx": "Effets sonores",
    "rpg.audio.ui": "Interface",
    "rpg.character-select.title": "Choisissez votre héros",
    "rpg.character-select.subtitle": "Sélectionnez le personnage avec lequel vous souhaitez commencer l’aventure.",
    "rpg.character-select.confirm": "Confirmer",
    "rpg.character-select.cancel": "Annuler",
    "rpg.character-select.previous": "Héros précédent",
    "rpg.character-select.next": "Héros suivant",
    "rpg.character-select.hint": "Vous pourrez personnaliser votre héros et ses compétences plus tard dans le jeu.",
    "rpg.character-select.stats": "Statistiques du héros",
    "rpg.character-select.stat.life": "Vie",
    "rpg.character-select.stat.strength": "Force",
    "rpg.character-select.stat.defense": "Défense",
    "rpg.character-select.stat.speed": "Vitesse",
    "rpg.character-select.stat.magic": "Magie",
  },
};

export function provideI18n(config: I18nConfig = {}) {
  return createI18nProvider(config);
}
